import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import CaseTypeStage from '../../entities/caseTypeStage';
import DeadlineRule from '../../entities/deadlineRule';
import MatterStage from '../../entities/matterStage';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteCaseTypeStage(): boolean {
return true;
}
export function collectCaseTypeStageDeleteImpact(caseTypeStage: CaseTypeStage, context: DeleteImpactContext): void {
const key = 'caseTypeStage:' + caseTypeStage.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const deadlineRuleTriggerStageIdImpact = workingRows<DeadlineRule>('deadlineRule', findAll<DeadlineRule>('deadlineRules')).filter(deadlineRuleRef => deadlineRuleRef.triggerStageId === caseTypeStage.id);
deadlineRuleTriggerStageIdImpact.forEach(deadlineRuleRef => addDeleteImpact(context, 'deadlineRule:' + deadlineRuleRef.id, 'deadlineRules'));
const matterStageCaseTypeStageIdImpact = workingRows<MatterStage>('matterStage', findAll<MatterStage>('matterStages')).filter(matterStageRef => matterStageRef.caseTypeStageId === caseTypeStage.id);
matterStageCaseTypeStageIdImpact.forEach(matterStageRef => addDeleteImpact(context, 'matterStage:' + matterStageRef.id, 'matterStages'));}
export function deleteImpactCaseTypeStage(caseTypeStage: CaseTypeStage): DeleteImpact {
const context = deleteImpactContext();
collectCaseTypeStageDeleteImpact(caseTypeStage, context);
return deleteImpactCounts(context);
}
export function deleteCaseTypeStage(caseTypeStage: CaseTypeStage, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteCaseTypeStage()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectCaseTypeStageDeleteImpact(caseTypeStage, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || caseTypeStage.id};
}
const key = 'caseTypeStage:' + caseTypeStage.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<DeadlineRule>('deadlineRule', [...store.getState().deadlineRules.getMappingFor('triggerStageId', caseTypeStage.id)]).filter(deadlineRuleTemp => deadlineRuleTemp.triggerStageId === caseTypeStage.id).forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
if (_deadlineRule.status === 'D') return;
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerStageId === caseTypeStage.id) {
_deadlineRule.triggerStageId = null;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule), 'deadlineRule:' + _deadlineRule.id);
});
workingRows<MatterStage>('matterStage', [...store.getState().matterStages.getMappingFor('caseTypeStageId', caseTypeStage.id)]).filter(matterStageTemp => matterStageTemp.caseTypeStageId === caseTypeStage.id).forEach(matterStageTemp => {
const _matterStage = ((_work.get('matterStage:' + matterStageTemp.id) ?? matterStageTemp) as MatterStage).clone();
if (_matterStage.status === 'D') return;
_matterStage.status = 'U';
_matterStage.addedOn = newHRTimestamp();
_matterStage.addedBy = getCurrentUserId();
_matterStage.importSource = targetImportSource;
_matterStage.importId = mergeId;
if (_matterStage.caseTypeStageId === caseTypeStage.id) {
_matterStage.caseTypeStageId = null;

}
_work.set('matterStage:' + _matterStage.id, _matterStage);
dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage), 'matterStage:' + _matterStage.id);
});
const deleted = caseTypeStage.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.CaseTypeStageActions.removeCaseTypeStageQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceCaseTypeStage(caseTypeStage: CaseTypeStage, replaceWith: CaseTypeStage, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = caseTypeStage.id;}
const _work = workingSet();
workingRows<DeadlineRule>('deadlineRule', [...store.getState().deadlineRules.getMappingFor('triggerStageId', caseTypeStage.id)]).filter(deadlineRuleTemp => deadlineRuleTemp.triggerStageId === caseTypeStage.id).forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
if (_deadlineRule.status === 'D') return;
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerStageId === caseTypeStage.id) {
_deadlineRule.triggerStageId = replaceWith.id;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
workingRows<MatterStage>('matterStage', [...store.getState().matterStages.getMappingFor('caseTypeStageId', caseTypeStage.id)]).filter(matterStageTemp => matterStageTemp.caseTypeStageId === caseTypeStage.id).forEach(matterStageTemp => {
const _matterStage = ((_work.get('matterStage:' + matterStageTemp.id) ?? matterStageTemp) as MatterStage).clone();
if (_matterStage.status === 'D') return;
_matterStage.status = 'U';
_matterStage.addedOn = newHRTimestamp();
_matterStage.addedBy = getCurrentUserId();
_matterStage.importSource = targetImportSource;
_matterStage.importId = mergeId;
if (_matterStage.caseTypeStageId === caseTypeStage.id) {
_matterStage.caseTypeStageId = replaceWith.id;

}
_work.set('matterStage:' + _matterStage.id, _matterStage);
store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
});



return caseTypeStage;
}
